import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VehicleData, VehicleCurrentInfo } from '../_shared/models/vehicle';

@Injectable({
  providedIn: 'root'
})
export class VehicleInfoService {

  constructor(private readonly httpClient: HttpClient) { }

  getAllVehicles(fleetId: string[]): Observable<VehicleData> {
    const fleetIds = fleetId.join(',');
    return this.httpClient.get<VehicleData>(environment.apiEndpoint + 'vehicles?fleetId=' + fleetIds);
  }

  getVehiclesWithPagination(page: number, limit: number, fleetId: string[]): Observable<VehicleData> {
    const fleetIds = fleetId.join(',');
    return this.httpClient.get<VehicleData>(environment.apiEndpoint + 'vehicles?page=' + page + '&limit=' + limit + '&fleetId=' + fleetIds + '&ingested=true');
  }

  getCurrentVehicleInfo(deviceSerialNumber: string[]):Observable<{[key: string]: VehicleCurrentInfo}> {
    return this.httpClient.get<{[key: string]: VehicleCurrentInfo}>(environment.apiEndpoint + 'state-of-health?batteryIdentifiers=' + deviceSerialNumber);
  }

  getFilteredVehicles(page: number, limit: number, fleetId: string[], vehicleBrand: string[], vehicleType: string[], productionYear: string[]): Observable<VehicleData> {
    const fleetIds = fleetId.join(',');
    const vehicleBrandParams = vehicleBrand.join(',')
    const vehicleTypeParams = vehicleType.join(',')
    const productionYearParams = productionYear.join(',')
    let url = '';

    if (vehicleBrandParams === '' && vehicleTypeParams !== '' && productionYearParams !== '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleType=${vehicleTypeParams}&productionYear=${productionYearParams}&ingested=true`;
    } else if (vehicleBrandParams !== '' && vehicleTypeParams === '' && productionYearParams !== '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleBrand=${vehicleBrandParams}&productionYear=${productionYearParams}&ingested=true`;
    } else if (vehicleBrandParams !== '' && vehicleTypeParams !== '' && productionYearParams === '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleBrand=${vehicleBrandParams}&vehicleType=${vehicleTypeParams}&ingested=true`;
    } else if (vehicleBrandParams !== '' && vehicleTypeParams === '' && productionYearParams === '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleBrand=${vehicleBrandParams}&ingested=true`;
    } else if (vehicleBrandParams === '' && vehicleTypeParams !== '' && productionYearParams === '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleType=${vehicleTypeParams}&ingested=true`;
    } else if (vehicleBrandParams === '' && vehicleTypeParams === '' && productionYearParams !== '') {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&productionYear=${productionYearParams}&ingested=true`;
    } else {
      url = `${environment.apiEndpoint}vehicles?page=${page}&limit=${limit}&fleetId=${fleetIds}&vehicleBrand=${vehicleBrandParams}&vehicleType=${vehicleTypeParams}&productionYear=${productionYearParams}&ingested=true`;
    }
    
    return this.httpClient.get<VehicleData>(url)
  }

  getNotIngestedVehicles(page: number, limit: number, fleetId: string[]): Observable<VehicleData> {
    const fleetIds = fleetId.join(',');
    return this.httpClient.get<VehicleData>(environment.apiEndpoint + 'vehicles?page=' + page + '&limit=' + limit + '&fleetId=' + fleetIds + '&supported=true');
  }

  getNotSupportedVehicles(page: number, limit: number, fleetId: string[]): Observable<VehicleData> {
    const fleetIds = fleetId.join(',');
    return this.httpClient.get<VehicleData>(environment.apiEndpoint + 'vehicles?page=' + page + '&limit=' + limit + '&fleetId=' + fleetIds + '&supported=false');
  }

  storeVehicles(body: any): Observable<any> {
    return this.httpClient.post<any>(environment.apiEndpoint + 'vehicles', body);
  }

  postIngestibleDevices(body: any): Observable<any> {
    return this.httpClient.post<any>(environment.apiEndpoint + 'ingestible-devices', body);
  }

  updateVehicles(vehicleId: string, body: any = {}): Observable<any> {
    const url = `${environment.apiEndpoint}vehicles/${vehicleId}`;
    return this.httpClient.put<any>(url, body, {
      headers: { 'accept': 'application/json' }
    });
  }

  getSupportedVehicles() {
    return this.httpClient.get<any>(environment.apiEndpoint + 'supported-vehicles');
  }

  getOrderNow(): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'order-now');
  }

  modifyFlag(body: any): Observable<any> {
    return this.httpClient.put<any>(environment.apiEndpoint + 'modify-flag', body);
  }

  requestVehicleConfigurationChange(body: any): Observable<any> {
    return this.httpClient.post<any>(environment.apiEndpoint + 'update-request', body, {headers: { 'accept': 'application/json' }});
  }

  getPendingRequests(databaseName: string, status: string): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'update-request?db=' + databaseName + '&status=' + status);
  }

  updateVehiclesGroup(body: { deviceId: string; batteryIdentifiers: string; group: boolean }[]): Observable<any> {
    return this.httpClient.post<any>(environment.apiEndpoint + 'vehicles-group', body);
  }
}
